import { isEmpty } from '../../core/util/empty';

const contentMapping = [
  ['Adult physicals', '/health-a-z/annual-physical'],
  ['X-Ray', '/health-a-z/x-ray'],
  ['DOT physicals', '/health-a-z/dot-physical'],
  ['School and sports physicals', '/health-a-z/school-physical'],
  ['Flu test', '/health-a-z/rapid-flu-test'],
  ['Abscess and Cyst Treatment', '/health-a-z/abscess-removal'],
  ['Pediatric physicals', '/health-a-z/pediatric-physical'],
  ['Strep test', '/health-a-z/strep-test'],
  ['Lab tests', '/health-a-z/lab-test'],
  ['Tetanus shot', '/health-a-z/tetanus-shot'],
  ['Sports physicals', '/health-a-z/sports-physical'],
  ['Pregnancy test', '/health-a-z/pregnancy-test'],
  ['Finger-stick Glucose Check', '/health-a-z/blood-glucose-test'],
  ['Ear wax removal', '/health-a-z/ear-wax-removal'],
  ['Travel medicine', '/health-a-z/travel-shots'],
  ['Pelvic exam', '/health-a-z/pelvic-exam'],
  ['Breathing treatments', '/health-a-z/breathing-treatment'],
  ['Diagnostic tests', '/health-a-z/lab-test'],
  ['Splinting and Casting', '/health-a-z/fractures'],
  ['Well woman exam', '/health-a-z/well-woman-exam'],
  ['Allergy Testing', '/health-a-z/allergy'],
  ['STD test', '/health-a-z/std-test'],
  ['Urine test', '/health-a-z/urinalysis'],
  ['Foreign body removal', '/health-a-z/foreign-body-removal'],
  ['Cyst treatment', '/health-a-z/cyst-removal'],
  ['Monospot test', '/health-a-z/mono'],
  ['Bloodwork', '/health-a-z/lab-test'],
  ['Minor burn care', '/health-a-z/burns'],
  ['Stitches', '/health-a-z/stitches'],
  ['Flu shot', '/health-a-z/flu-shot'],
  ['Glucose checks', '/health-a-z/blood-glucose-test'],
  ['Laceration Repair', '/health-a-z/cuts'],
  ['Asthma treatment', '/health-a-z/asthma'],
  ['TB test', '/health-a-z/tuberculosis'],
  ['Comprehensive Metabolic Panel', '/health-a-z/comprehensive-metabolic-panel'],
  ['Daycare Physical', '/health-a-z/daycare-physical'],
  ['Employment Physical', '/health-a-z/employment-physical'],
  ['Hearing Test', '/health-a-z/hearing-test'],
  ['HIV Test', '/health-a-z/hiv-test'],
  ['Urine culture', '/health-a-z/urine-culture'],
  ['Strep A Throat Culture', '/health-a-z/strep-a-throat-culture'],
  ['Vaccinations', '/health-a-z/vaccinations'],
];

const contentSynonyms = {
  'Glucose checks': 'Blood glucose test',
  'School and sports physicals': 'School physicals',
  'Abscess and Cyst Treatment': 'Abscess removal',
  'Travel medicine': 'Travel shots',
  'Urine test': 'Urinalysis',
  'Cyst treatment': 'Cyst removal',
};

export const getSynonym = service =>
  !isEmpty(contentSynonyms[service]) ? contentSynonyms[service] : service;

export default new Map(contentMapping);
